import { useDispatch } from "react-redux";
import { Select } from "../../ui/Select/Select";
import {
  setNewAssistant,
  setUpdateAssistant,
} from "../../../../store/slices/assistantSlice";

const TimeZoneSelector = ({ newAssistant, updateAssistant }) => {
  const dispatch = useDispatch();

  // Уникальные временные зоны
  const timeZones = [
    { label: "UTC -12", value: "-12" },
    { label: "UTC -11", value: "-11" },
    { label: "UTC -10", value: "-10" },
    { label: "UTC -09", value: "-9" },
    { label: "UTC -08", value: "-8" },
    { label: "UTC -07", value: "-7" },
    { label: "UTC -06", value: "-6" },
    { label: "UTC -05", value: "-5" },
    { label: "UTC -04", value: "-4" },
    { label: "UTC -03", value: "-3" },
    { label: "UTC -02", value: "-2" },
    { label: "UTC -01", value: "-1" },
    { label: "UTC +00", value: "0" },
    { label: "UTC +01", value: "1" },
    { label: "UTC +02", value: "2" },
    { label: "UTC +03", value: "3" },
    { label: "UTC +04", value: "4" },
    { label: "UTC +05", value: "5" },
    { label: "UTC +06", value: "6" },
    { label: "UTC +07", value: "7" },
    { label: "UTC +08", value: "8" },
    { label: "UTC +09", value: "9" },
    { label: "UTC +10", value: "10" },
    { label: "UTC +11", value: "11" },
    { label: "UTC +12", value: "12" },
  ];

  // Функция для обработки выбранной временной зоны
  const handleTimeZoneChange = (option) => {
    const timeZoneValue = parseInt(option);
    
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: { ...newAssistant.settings, timeZone: timeZoneValue },
      };
      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: { ...updateAssistant.settings, timeZone: timeZoneValue },
      };
      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const getCurrentTimeZone = () => {
    const timeZone = updateAssistant?.settings?.timeZone ?? newAssistant?.settings?.timeZone;
    return timeZone !== undefined ? String(timeZone) : "3"; // По умолчанию UTC+3
  };

  return (
    <div>
      <Select
        options={timeZones}
        value={getCurrentTimeZone()}
        onChange={handleTimeZoneChange}
        placeholder="Выберите временную зону..."
        isTimeZone={true}
      />
    </div>
  );
};

export default TimeZoneSelector;
